export enum WebMessageType {
	Contact = "Contact",
}
